export default "__VITE_PUBLIC_ASSET__3f35883d__"